"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28.4,13.8,26,12l-.56-4.47a4,4,0,0,0-4-3.53H10.55a4,4,0,0,0-4,3.53L6,12,3.6,13.8A4,4,0,0,0,2,17v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V17A4,4,0,0,0,28.4,13.8ZM8.72,7.67a2,2,0,0,1,2-1.67H21.31a2,2,0,0,1,2,1.67L24,12H8ZM8,20a2,2,0,1,1,2-2A2,2,0,0,1,8,20Zm16,0a2,2,0,1,1,2-2A2,2,0,0,1,24,20Z"/><path d="M18.5,8A3.5,3.5,0,0,0,15,11.5a4,4,0,0,0,.05.5h2a1.64,1.64,0,0,1-.09-.5,1.5,1.5,0,0,1,3,0,1.64,1.64,0,0,1-.09.5h2a4,4,0,0,0,.05-.5A3.5,3.5,0,0,0,18.5,8Z"/><path d="M5,24v2a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V24Z"/><path d="M21,24v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V24Z"/>';
var CarSVG = function CarSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CarSVG = CarSVG;
CarSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CarSVG);
exports.default = _default;